<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 2 }"
        [routerLink]="card.route"
        [style.cursor]="card.route || i === 2 || 1 ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow icon-card"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <!-- <a class="btn btn-dark btn-sm btn-step"> Instagram </a>
        <a class="btn btn-dark btn-sm btn-step"> Facebook </a>
        <a class="btn btn-dark btn-sm btn-step"> YouTube </a>
        <a class="btn btn-dark btn-sm btn-step"> TikTok </a>
        <a class="btn btn-dark btn-sm btn-step"> LinkedIn </a> -->
        <a
          class="btn btn-dark btn-sm btn-step"
          routerLink="/marketing/social/contentRequests"
          >Content Requests
        </a>
        <a
          class="btn btn-dark btn-sm btn-step"
          routerLink="/marketing/social/registry"
          >Social Registry
        </a>
      </div>

      <div style="width: 40px"></div>
    </div>
  </div>
  <!-- Campo de búsqueda mejorado con autocompletado -->
  <div class="row mb-3">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filterInfo()"
          list="suggestions"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="suggestions">
          <option
            *ngFor="let sugerencia of sugerenciasBusqueda"
            [value]="sugerencia"
          ></option>
        </datalist>
      </div>
    </div>
  </div>
</div>
